import * as React from 'react';
export const IcGhost = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12 2a8 8 0 00-8 8v9.82a.94.94 0 001 .95.88.88 0 00.73-.37l.24-.31a1 1 0 01.74-.37.93.93 0 01.77.41l1 1.42a1 1 0 00.79.41.92.92 0 00.73-.35l1.3-1.58a.909.909 0 01.73-.34.94.94 0 01.76.4l1 1.47a.93.93 0 00.77.4.92.92 0 00.73-.35L16.55 20a1.001 1.001 0 01.73-.35.9.9 0 01.74.37l.29.38a.91.91 0 00.74.37.94.94 0 00.95-.95V10a8 8 0 00-8-8zM8.71 12.16a2.51 2.51 0 11-.02-5.02 2.51 2.51 0 01.02 5.02zm6.57 0a2.51 2.51 0 11-.02-5.02 2.51 2.51 0 01.02 5.02z'
      fill='currentColor'
    />
  </svg>
);
